import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DashboardPage() {
  const navigate = useNavigate();
  const stats = [
    { label: "Today's Revenue", value: '$42,180', change: '+8% vs yesterday', color: '#16A34A', icon: '\uD83D\uDCB0' },
    { label: 'Transactions', value: '1,247', change: '+12% vs last week', color: '#3B82F6', icon: '\uD83D\uDED2' },
    { label: 'Avg Basket', value: '$33.82', change: '$31.50 last week', color: '#6366F1', icon: '\uD83D\uDCC8' },
    { label: 'Shrinkage Rate', value: '1.8%', change: 'Target: <2%', color: '#F97316', icon: '\uD83D\uDEA8' },
  ];
  const quickActions = [
    { label: 'Product Catalog', icon: '\uD83D\uDED2', action: '/product-catalog' },
    { label: 'Inventory', icon: '\uD83D\uDCE6', action: '/inventory' },
    { label: 'Receiving Dock', icon: '\uD83D\uDCE5', action: '/receiving' },
    { label: 'Janitorial', icon: '\uD83E\uDDF9', action: '/janitorial' },
    { label: 'Weekly Deals', icon: '\uD83D\uDCF0', action: '/weekly-deals' },
    { label: 'Daily Sales', icon: '\uD83D\uDCC8', action: '/daily-sales' },
  ];

  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Dashboard</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>AisleSync &mdash; Grocery & Retail Management</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 28 }}>
        {stats.map((s, i) => (
          <div key={i} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{s.label}</span>
              <span style={{ fontSize: 20 }}>{s.icon}</span>
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, color: s.color, marginBottom: 4 }}>{s.value}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{s.change}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16, marginBottom: 20 }}>
        <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
          <div style={{ padding: '18px 20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: 0 }}>Low Stock Alerts</h2>
            <button onClick={() => navigate('/inventory')} style={{ background: 'none', border: 'none', color: 'var(--primary)', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>View All</button>
          </div>
          {[
            { item: 'Organic Whole Milk 4L', dept: 'Dairy', current: 8, par: 40, urgency: 'Critical' },
            { item: 'Bananas (bunch)', dept: 'Produce', current: 12, par: 60, urgency: 'Critical' },
            { item: 'Sourdough Bread', dept: 'Bakery', current: 6, par: 24, urgency: 'Warning' },
            { item: 'Ground Beef 1lb', dept: 'Meat', current: 15, par: 50, urgency: 'Warning' },
            { item: 'Paper Towels 6pk', dept: 'Household', current: 18, par: 45, urgency: 'Low' },
          ].map((s, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', borderBottom: '1px solid var(--border)' }}>
              <div>
                <div style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{s.item}</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>{s.dept} &middot; {s.current}/{s.par} units</div>
              </div>
              <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: s.urgency === 'Critical' ? '#EF444420' : s.urgency === 'Warning' ? '#F59E0B20' : '#3B82F620', color: s.urgency === 'Critical' ? '#EF4444' : s.urgency === 'Warning' ? '#F59E0B' : '#3B82F6' }}>{s.urgency}</span>
            </div>
          ))}
        </div>
        <div style={{ padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: '0 0 16px' }}>Quick Actions</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {quickActions.map((qa, i) => (
              <button key={i} onClick={() => navigate(qa.action)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text)', fontSize: 13, fontWeight: 500, cursor: 'pointer', textAlign: 'left', width: '100%' }}>
                <span style={{ fontSize: 18 }}>{qa.icon}</span>{qa.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={{ padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: '0 0 16px' }}>Janitorial Status</h2>
          {[
            { zone: 'Restrooms', lastCleaned: '45 min ago', status: 'Due Soon' },
            { zone: 'Produce Aisle', lastCleaned: '20 min ago', status: 'Clean' },
            { zone: 'Checkout Area', lastCleaned: '1h 10m ago', status: 'Overdue' },
            { zone: 'Deli Counter', lastCleaned: '30 min ago', status: 'Clean' },
          ].map((z, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: i < 3 ? '1px solid var(--border)' : 'none' }}>
              <div>
                <div style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{z.zone}</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>Last: {z.lastCleaned}</div>
              </div>
              <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: z.status === 'Overdue' ? '#EF444420' : z.status === 'Due Soon' ? '#F59E0B20' : '#16A34A20', color: z.status === 'Overdue' ? '#EF4444' : z.status === 'Due Soon' ? '#F59E0B' : '#16A34A' }}>{z.status}</span>
            </div>
          ))}
        </div>
        <div style={{ padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
          <h2 style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: '0 0 16px' }}>Online Orders</h2>
          {[
            { id: 'ORD-4821', customer: 'Sarah M.', items: 14, total: '$87.50', type: 'Delivery', status: 'Picking' },
            { id: 'ORD-4820', customer: 'Mike T.', items: 8, total: '$42.30', type: 'Pickup', status: 'Ready' },
            { id: 'ORD-4819', customer: 'Lisa K.', items: 22, total: '$156.80', type: 'Delivery', status: 'Packed' },
            { id: 'ORD-4818', customer: 'James R.', items: 5, total: '$28.90', type: 'Pickup', status: 'Picked Up' },
          ].map((o, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: i < 3 ? '1px solid var(--border)' : 'none' }}>
              <div>
                <div style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{o.customer} &middot; {o.items} items</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>{o.id} &middot; {o.type} &middot; {o.total}</div>
              </div>
              <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: o.status === 'Ready' ? '#16A34A20' : o.status === 'Picking' ? '#3B82F620' : '#6366F120', color: o.status === 'Ready' ? '#16A34A' : o.status === 'Picking' ? '#3B82F6' : '#6366F1' }}>{o.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
